// Christina P-05: reveal-on-scroll, quiz teaser chips, and pointer interactions. No dependencies.
// Every effect is an enhancement: content and links work without JS, and pointer effects are
// skipped for touch devices and for prefers-reduced-motion.
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // ---- Reveal on scroll ----
  const items = document.querySelectorAll('.cj-reveal, .cj-mask');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach((el) => io.observe(el));
    // Never leave content hidden (print, crawlers, slow observers).
    window.addEventListener('beforeprint', () => items.forEach((el) => el.classList.add('is-in')));
    setTimeout(() => document.querySelectorAll('.cj-reveal:not(.is-in), .cj-mask:not(.is-in)').forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    }), 2500);
  }

  // ---- Quiz teaser: pick a colour, see a playful line; the stage takes that colour. ----
  // Prototype only: nothing is stored or sent.
  document.querySelectorAll('[data-cj-quiz]').forEach((quiz) => {
    const out = quiz.querySelector('[data-cj-quiz-answer]');
    const stage = quiz.querySelector('.cj-quiz__stage');
    quiz.querySelectorAll('[data-cj-quiz-choice]').forEach((btn) => {
      btn.addEventListener('click', () => {
        quiz.querySelectorAll('[data-cj-quiz-choice]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        out.textContent = btn.dataset.cjQuizChoice;
        const sw = btn.querySelector('.cj-swatch');
        if (stage && sw) stage.style.setProperty('--cj-pick', getComputedStyle(sw).getPropertyValue('--cj-sw').trim());
        btn.classList.remove('is-popped');
        void btn.offsetWidth; // restart the pop animation
        btn.classList.add('is-popped');
      });
    });
  });

  // ---- Pointer interactions (desktop mouse/trackpad only) ----
  if (!reduce && finePointer) {
    // rAF-throttled CSS-variable writer
    const onMove = (el, fn) => {
      let frame = 0;
      el.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => fn(e));
      });
    };
    const relative = (el, e) => {
      const r = el.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width - 0.5, y: (e.clientY - r.top) / r.height - 0.5 };
    };

    // 1. Hero parallax (max 12px image, 6px panel)
    document.querySelectorAll('.cj-hero').forEach((hero) => {
      onMove(hero, (e) => {
        const { x, y } = relative(hero, e);
        hero.style.setProperty('--px', x.toFixed(3));
        hero.style.setProperty('--py', y.toFixed(3));
      });
      hero.addEventListener('pointerleave', () => { hero.style.setProperty('--px', 0); hero.style.setProperty('--py', 0); });
    });

    // 2. Colour tiles tilt toward the pointer (max 5deg) with a moving sheen
    document.querySelectorAll('a.cj-colour').forEach((tile) => {
      onMove(tile, (e) => {
        const { x, y } = relative(tile, e);
        tile.style.setProperty('--tx', x.toFixed(3));
        tile.style.setProperty('--ty', y.toFixed(3));
      });
      tile.addEventListener('pointerleave', () => { tile.style.setProperty('--tx', 0); tile.style.setProperty('--ty', 0); });
    });

    // 3. Magnetic buttons (max 6px)
    document.querySelectorAll('.cj-btn:not([aria-disabled="true"])').forEach((btn) => {
      onMove(btn, (e) => {
        const { x, y } = relative(btn, e);
        btn.style.setProperty('--mx', `${(x * 12).toFixed(1)}px`);
        btn.style.setProperty('--my', `${(y * 12).toFixed(1)}px`);
      });
      btn.addEventListener('pointerleave', () => { btn.style.setProperty('--mx', '0px'); btn.style.setProperty('--my', '0px'); });
    });
  }

  // ---- P-06: collection intro clamp. Full text remains available without JS. ----
  document.querySelectorAll('.cj-colhead [data-cj-clamp]').forEach((intro) => {
    const toggle = intro.parentElement.querySelector('[data-cj-clamp-toggle]');
    if (!toggle) return;
    const mobile = window.matchMedia('(max-width: 749px)');
    const more = toggle.textContent;
    let expanded = false;
    let frame = 0;
    const update = () => {
      intro.classList.toggle('is-clamped', mobile.matches);
      const needed = mobile.matches && intro.scrollHeight > intro.clientHeight + 2;
      if (!needed) expanded = false;
      intro.classList.toggle('is-clamped', needed && !expanded);
      toggle.hidden = !needed;
      toggle.setAttribute('aria-expanded', String(needed && expanded));
      toggle.textContent = expanded ? 'Show less' : more;
    };
    toggle.addEventListener('click', () => { expanded = !expanded; update(); });
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    mobile.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    if (document.fonts) document.fonts.ready.then(schedule);
    update();
  });

  root.classList.add('cj-ready');
})();
